export function addComma(value: any) {
  const number = Number(value);
  if (Number.isNaN(number)) {
    return value;
  }
  return number.toLocaleString();
}
export function zeroPadding(value: any, num: any) {
  return ("00000000000000" + value).slice(num * -1);
}

export function truncate(value: any, length = 20, omission = "...") {
  // if (length === false) {
  //   return value;
  // }
  const stringLength = parseInt(length.toString(), 10);
  const stringOmmision = omission.toString();

  if (value.length <= stringLength) {
    return value;
  }
  return value.substring(0, stringLength) + stringOmmision;
}

export function getDateString() {
  const date = new Date();
  const year = date.getFullYear().toString();
  const month = date.getMonth() + 1;
  return (
    year +
    month +
    date.getDate() +
    date.getHours() +
    date.getMinutes() +
    date.getSeconds()
  );
}
